import Button from '../../Button/Button';
import Input from '../../Input/Input';
import ModalWrapper from '../../ModalWrapper/ModalWrapper';
import Select from '../../Select/Select';
import Text from '../../Text/Text';
import Title from '../../Title/Title';
import UploadImg from '../../UploadImg/UploadImg';
import style from './PromotedSpot.module.scss';
import icon from './assets/img.svg';
import stars from './assets/stars.svg';
import projectIcon from './assets/project-img.jpg';

const PromotedSpotModal = ({ close }) => {
  return (
    <ModalWrapper closeModal={close} withCalendar>
      <div className={style.modal}>
        <div className={style.modal__icon}>
          <img src={icon} alt='' />

          <div className={style.modal__iconStars}>
            <img src={stars} alt='' />
          </div>
        </div>
        <Title.H2>Promoted Spot</Title.H2>
        <Text grey center>
          Your coin will appear in <br /> Promoted section on main page
        </Text>
        <Select
          className={style.modal__select}
          big
          border
          isProjectList
          options={[
            {
              name: 'Select your project',
              value: '',
            },
            {
              icon: projectIcon,
              name: 'Memereum',
              category: 'Meme',
              chain: 'BSC',
              address: '0xDbC3...e382',
              value: 'project_1',
            },
            {
              icon: projectIcon,
              name: 'Memereum',
              category: 'Meme',
              chain: 'BSC',
              address: '0xDbC3...e382',
              value: 'project_1',
            },
            {
              icon: projectIcon,
              name: 'Memereum',
              category: 'Meme',
              chain: 'BSC',
              address: '0xDbC3...e382',
              value: 'project_1',
            },
            {
              icon: projectIcon,
              name: 'Memereum',
              category: 'Meme',
              chain: 'BSC',
              address: '0xDbC3...e382',
              value: 'project_1',
            },
            {
              icon: projectIcon,
              name: 'Memereum',
              category: 'Meme',
              chain: 'BSC',
              address: '0xDbC3...e382',
              value: 'project_1',
            },
            {
              icon: projectIcon,
              name: 'Memereum',
              category: 'Meme',
              chain: 'BSC',
              address: '0xDbC3...e382',
              value: 'project_1',
            },
            {
              icon: projectIcon,
              name: 'Memereum',
              category: 'Meme',
              chain: 'BSC',
              address: '0xDbC3...e382',
              value: 'project_1',
            },
            {
              icon: projectIcon,
              name: 'Memereum',
              category: 'Meme',
              chain: 'BSC',
              address: '0xDbC3...e382',
              value: 'project_1',
            },
          ]}
        />
        <Button className={style.modal__add} filled>
          Add to Cart
        </Button>
        <Button noBorder whiteText>
          Show position
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default PromotedSpotModal;
